import { Row, Col, OverlayTrigger, Tooltip, Badge } from 'react-bootstrap';
import NumericalField from '../fields/NumericalField';
import CurrencyField from '../fields/CurrencyField';
import { MIN_HOUSEHOLD_SIZE, MAX_HOUSEHOLD_SIZE } from '../../../constants/constants';

const IncomeInformationInputs = ({
  householdSize,
  onHouseholdSizeChange,
  income,
  onIncomeChange,
  arrearsLiabilityAmount,
  onArrearsLiabilityAmountChange,
  isSubmitting,
}) => {

  return (
    <Row>
      <Col>
        <CurrencyField
          value={income}
          fieldName="Monthly Adjusted Household Income"
          required
          onChange={onIncomeChange}
          isSubmitting={isSubmitting}
        />
      </Col>
      <Col>
        <NumericalField
          fieldName="Household Size"
          min={MIN_HOUSEHOLD_SIZE}
          max={MAX_HOUSEHOLD_SIZE}
          value={householdSize}
          onChange={onHouseholdSizeChange}
          isSubmitting={isSubmitting}
        />
      </Col>

      {arrearsLiabilityAmount !== undefined && (
        <>
          <Col>
            <CurrencyField
                value={arrearsLiabilityAmount}
                fieldName="Arrears Liability Amount"
                onChange={onArrearsLiabilityAmountChange}
                required
                isSubmitting={isSubmitting}
            />
            </Col>

            <Col xs={1} className="align-content-center">
            <OverlayTrigger
              placement="right"
              overlay={
                <Tooltip id="arrears-liability-tooltip">
                  Enter the customer's current arrears balance.
                </Tooltip>
              }
            >
            <Badge
              bg="secondary"
              pill
              style={{ cursor: 'help' }}
              aria-label="More information"
            >?</Badge>
          </OverlayTrigger>
          </Col>
        </>
      )}
    </Row>
  );
};

export default IncomeInformationInputs;